export const DEFAULT_FETCH_PARAM_SIZE = 5000;
export const MINIMUM_FETCH_PARAM_SIZE = 100;
